<template>
  <DisabledTooltip
    :block_class="blockClass"
    :condition="condition"
    data-qa="in-development-block"
    :prevent="prevent"
    tooltip_class="in-development-info"
    :tooltip_text="$t('Common.InDeveloping')"
    :top="top">
    <template v-slot:activator="{ on }">
      <slot
        name="activator"
        :on="on"/>
    </template>
  </DisabledTooltip>
</template>
<script>
import DisabledTooltip from 'components/common/elements/DisabledTooltip.vue'

export default {
  name: 'inDevelopmentInfo',
  props: {
    condition: Boolean,
    top: Boolean,
    prevent: Boolean,
    blockClass: {
      type: String,
      default: 'in-development-block'
    }
  },
  components: {
    DisabledTooltip
  }
}
</script>
<style lang="scss">
.in-development-info {
  color: 2px solid var(--v-secondary__red-base);
}
</style>
